var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('span',_vm._g({staticClass:"nx-list-item-flag",style:(("border-color: transparent transparent " + _vm.calculatedColor + " transparent"))},on))]}}])},[_c('strong',{domProps:{"textContent":_vm._s(_vm.translatedTooltip)}})])}
var staticRenderFns = []

export { render, staticRenderFns }